import FloatingFilterInput from '../../../../component/Common/Datagrid/Component/FloatingFilterRenderer/FloatingFilterInput';
import {
  generateFormattedDay,
  generateFormattedTime,
} from '../../Common/Generator/formattedDayGenerator';
import {
  DAILY_IN_OUT_CATEGORY_TYPE,
  DAILY_IN_OUT_TYPE,
} from '../../../../constant/DailyInOut/elements';
import dateComparator from '../../../Common/Datagrid/Comparator/dateComparator';
import generateAgingDate from '../generateAgingDate';
import generateDateFilters from '../../../Common/Datagrid/Generator/generateDateFilters';

const createContainerColumnDefs = () => {
  return [
    {
      headerName: 'DATE',
      field: 'created_date',
      width: 62,
      editable: false,
      cellClass: 'date',
      valueGetter: params =>
        generateFormattedDay(
          params?.data?.created_date
            ? params?.data?.created_date.split(' ')[0]
            : '',
          'MM/DD/YY',
        ),
      comparator: dateComparator,
      ...generateDateFilters(),
    },
    {
      headerName: 'TIME',
      field: 'created_time',
      width: 48,
      editable: false,
      valueGetter: params =>
        generateFormattedTime(
          params?.data?.created_date
            ? params?.data?.created_date.split(' ')[1]
            : '',
        ),
      floatingFilterComponent: FloatingFilterInput,
      floatingFilterComponentParams: {
        inputType: 'time',
        maxLength: 5,
        placeholder: 'HH:mm',
      },
    },
    {
      headerName: 'AGING',
      field: 'aging',
      width: 55,
      editable: false,
      valueGetter: params => generateAgingDate(params?.data?.created_date),
    },
    {
      headerName: 'YARD',
      field: 'yard',
      width: 70,
      editable: false,
      floatingFilter: false,
    },
    {
      headerName: 'WO #',
      field: 'wo_no',
      width: 100,
      editable: false,
    },
    {
      headerName: 'WO DIV',
      field: 'wo_div',
      width: 65,
      editable: false,
    },
    {
      headerName: 'CAT',
      field: 'category',
      width: 55,
      editable: false,
      valueGetter: params =>
        DAILY_IN_OUT_CATEGORY_TYPE?.[params?.data?.category] ||
        params?.data?.category,
    },
    {
      headerName: 'STATUS',
      field: 'status',
      width: 80,
      editable: false,
      valueGetter: params =>
        DAILY_IN_OUT_TYPE?.[params?.data?.status] || params?.data?.status,
    },
    {
      headerName: 'LOC',
      field: 'yard_location',
      width: 72,
      editable: false,
    },
    {
      headerName: 'RFD',
      field: 'rfd',
      width: 62,
      editable: false,
      cellClass: 'date',
      valueGetter: params =>
        generateFormattedDay(
          params?.data?.rfd ? params?.data?.rfd.split(' ')[0] : '',
          'MM/DD/YY',
        ),
      comparator: dateComparator,
      ...generateDateFilters(),
    },
    {
      headerName: 'CONT #',
      field: 'cont_no',
      width: 92,
      editable: false,
    },
    {
      headerName: 'SIZE',
      field: 'size',
      width: 46,
      editable: false,
    },
    {
      headerName: 'TYPE',
      field: 'type',
      width: 77,
      editable: false,
    },
    {
      headerName: 'SSL',
      field: 'ssl',
      width: 50,
      editable: false,
    },
    {
      headerName: 'SEAL #',
      field: 'seal',
      width: 150,
      editable: false,
    },
    {
      headerName: 'REMARKS',
      field: 'remarks',
      editable: false,
    },
  ];
};

export default createContainerColumnDefs;
